module.exports = __webpack_public_path__ + "img/clients_img_01.978a9468.jpg";